import application from 'application/application';

import template from './default.template.html';

import menuBarTemplate from './partials/menu-bar.template.html';

import toolbarTemplate from './partials/toolbar.template.html';

import menuMobileBarTemplate from './partials/menu-mobile-bar.template.html';

import controller from './default.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default', {
				abstract: true,
				views: {
					'root': {
						templateUrl: template,
						controller
					},
					'menuMobileBar@root.default': {
						templateUrl: menuMobileBarTemplate
					},
					'menuBar@root.default': {
						templateUrl: menuBarTemplate
					},
					'toolbar@root.default': {
						templateUrl: toolbarTemplate
					}
				},
				params: {
					authentication: true
				}
			});

	}]);
